/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateClientAppointmentRequest
 */
export interface CreateClientAppointmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateClientAppointmentRequest
     */
    originTimeZoneId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateClientAppointmentRequest
     */
    slotAppointmentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientAppointmentRequest
     */
    purposeKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientAppointmentRequest
     */
    assignedCounselorId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateClientAppointmentRequest
     */
    startTimeUtc?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateClientAppointmentRequest
     */
    endTimeUtc?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClientAppointmentRequest
     */
    location?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClientAppointmentRequest
     */
    notifyBySms?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClientAppointmentRequest
     */
    notifyByEmail?: boolean;
}

/**
 * Check if a given object implements the CreateClientAppointmentRequest interface.
 */
export function instanceOfCreateClientAppointmentRequest(value: object): value is CreateClientAppointmentRequest {
    if (!('originTimeZoneId' in value) || value['originTimeZoneId'] === undefined) return false;
    return true;
}

export function CreateClientAppointmentRequestFromJSON(json: any): CreateClientAppointmentRequest {
    return CreateClientAppointmentRequestFromJSONTyped(json, false);
}

export function CreateClientAppointmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClientAppointmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'originTimeZoneId': json['originTimeZoneId'],
        'slotAppointmentId': json['slotAppointmentId'] == null ? undefined : json['slotAppointmentId'],
        'purposeKey': json['purposeKey'] == null ? undefined : json['purposeKey'],
        'assignedCounselorId': json['assignedCounselorId'] == null ? undefined : json['assignedCounselorId'],
        'startTimeUtc': json['startTimeUtc'] == null ? undefined : (new Date(json['startTimeUtc'])),
        'endTimeUtc': json['endTimeUtc'] == null ? undefined : (new Date(json['endTimeUtc'])),
        'location': json['location'] == null ? undefined : json['location'],
        'notifyBySms': json['notifyBySms'] == null ? undefined : json['notifyBySms'],
        'notifyByEmail': json['notifyByEmail'] == null ? undefined : json['notifyByEmail'],
    };
}

export function CreateClientAppointmentRequestToJSON(json: any): CreateClientAppointmentRequest {
    return CreateClientAppointmentRequestToJSONTyped(json, false);
}

export function CreateClientAppointmentRequestToJSONTyped(value?: CreateClientAppointmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'originTimeZoneId': value['originTimeZoneId'],
        'slotAppointmentId': value['slotAppointmentId'],
        'purposeKey': value['purposeKey'],
        'assignedCounselorId': value['assignedCounselorId'],
        'startTimeUtc': value['startTimeUtc'] == null ? value['startTimeUtc'] : value['startTimeUtc'].toISOString(),
        'endTimeUtc': value['endTimeUtc'] == null ? value['endTimeUtc'] : value['endTimeUtc'].toISOString(),
        'location': value['location'],
        'notifyBySms': value['notifyBySms'],
        'notifyByEmail': value['notifyByEmail'],
    };
}

